import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eaa2444"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "ModalCompetitorsInfo",
  tabindex: "-1",
  "aria-labelledby": `ModalCompetitorsInfo`,
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = {
  class: "modal-content",
  style: {"overflow":"hidden"}
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-7eaa2444><g clip-path=\"url(#clip0_370_130)\" data-v-7eaa2444><path d=\"M17.4313 35.9687L13.6188 34.8625C13.2188 34.75 12.9938 34.3312 13.1063 33.9312L21.6376 4.54375C21.7501 4.14375 22.1688 3.91875 22.5688 4.03125L26.3813 5.1375C26.7813 5.25 27.0063 5.66875 26.8938 6.06875L18.3626 35.4562C18.2438 35.8562 17.8313 36.0875 17.4313 35.9687ZM10.3063 28.9562L13.0251 26.0562C13.3126 25.75 13.2938 25.2625 12.9751 24.9812L7.3126 20L12.9751 15.0187C13.2938 14.7375 13.3188 14.25 13.0251 13.9437L10.3063 11.0437C10.0251 10.7437 9.5501 10.725 9.24385 11.0125L0.237598 19.45C-0.0811523 19.7437 -0.0811523 20.25 0.237598 20.5437L9.24385 28.9875C9.5501 29.275 10.0251 29.2625 10.3063 28.9562ZM30.7563 28.9937L39.7626 20.55C40.0813 20.2562 40.0813 19.75 39.7626 19.4562L30.7563 11.0062C30.4563 10.725 29.9813 10.7375 29.6938 11.0375L26.9751 13.9375C26.6876 14.2437 26.7063 14.7312 27.0251 15.0125L32.6876 20L27.0251 24.9812C26.7063 25.2625 26.6813 25.75 26.9751 26.0562L29.6938 28.9562C29.9751 29.2625 30.4501 29.275 30.7563 28.9937Z\" fill=\"#E8E8E8\" data-v-7eaa2444></path></g><defs data-v-7eaa2444><clipPath id=\"clip0_370_130\" data-v-7eaa2444><rect width=\"40\" height=\"40\" fill=\"white\" data-v-7eaa2444></rect></clipPath></defs></svg>", 1)
const _hoisted_6 = {
  style: {"margin-right":"auto"},
  class: "ps-4"
}
const _hoisted_7 = {
  class: "modal-title",
  id: "ModalCompetitorsInfo",
  style: {"color":"var(--cor_texto_1)"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  style: {"background-color":"transparent","border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "#B5B5C3",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.6062 10L16.5152 6.09102C16.9949 5.61133 16.9949 4.83359 16.5152 4.35352L15.6465 3.48477C15.1668 3.00508 14.3891 3.00508 13.909 3.48477L10 7.39375L6.09102 3.48477C5.61133 3.00508 4.83359 3.00508 4.35352 3.48477L3.48477 4.35352C3.00508 4.8332 3.00508 5.61094 3.48477 6.09102L7.39375 10L3.48477 13.909C3.00508 14.3887 3.00508 15.1664 3.48477 15.6465L4.35352 16.5152C4.8332 16.9949 5.61133 16.9949 6.09102 16.5152L10 12.6062L13.909 16.5152C14.3887 16.9949 15.1668 16.9949 15.6465 16.5152L16.5152 15.6465C16.9949 15.1668 16.9949 14.3891 16.5152 13.909L12.6062 10Z",
      fill: "#B5B5C3"
    })
  ])
], -1))
const _hoisted_9 = {
  class: "modal-body p-4",
  style: {"background-color":"var(--cor_background_2)"}
}
const _hoisted_10 = {
  key: 0,
  class: "card p-4",
  style: {"color":"var(--cor_texto_1)"}
}
const _hoisted_11 = { class: "d-md-block col-md-3 col-xl-1" }
const _hoisted_12 = {
  id: "form-product-store-product-img",
  class: "d-flex justify-content-center align-items-center rounded p-3"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nível: ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Data de cadastro: ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Cadastro atualizado em: ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Data de nascimento: ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Último acesso: ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "N° do cartão: ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "N° do pin: ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.header), 1)
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.competitor)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.competitor.url_photo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "h-100 h-md-auto w-md-100 object-fit-contain px-2",
                          src: _ctx.competitor.url_photo,
                          alt: ""
                        }, null, 8, _hoisted_13))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "h-100 h-md-auto w-md-100 object-fit-contain px-2",
                          src: _ctx.imgDefault,
                          alt: ""
                        }, null, 8, _hoisted_14))
                  ])
                ]),
                _createElementVNode("p", null, [
                  _hoisted_15,
                  _createTextVNode(_toDisplayString(_ctx.getRoleName(_ctx.competitor.id_role)), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_16,
                  _createTextVNode(_toDisplayString(_ctx.competitor.created_at ? _ctx.moment(_ctx.competitor.created_at).format('DD/MM/YYYY') : "N/A"), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_17,
                  _createTextVNode(_toDisplayString(_ctx.competitor.updated_at ? _ctx.moment(_ctx.competitor.updated_at).format('DD/MM/YYYY') : "N/A"), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_18,
                  _createTextVNode(_toDisplayString(_ctx.competitor.birth_date ? _ctx.moment(_ctx.competitor.birth_date).format('DD/MM/YYYY') : "N/A"), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_19,
                  _createTextVNode(_toDisplayString(_ctx.competitor.latestAccess ? _ctx.moment(_ctx.competitor.latestAccess).format('DD/MM/YYYY') : "N/A"), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_20,
                  _createTextVNode(_toDisplayString(_ctx.competitor.card_number || "N/A"), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_21,
                  _createTextVNode(_toDisplayString(_ctx.competitor.card_pin || "N/A"), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}